import ButtonWithTooltip from '@/components/ButtonWithTooltip'
import CreateLayoutDialog from '@/components/CreateLayoutDialog'
import LayoutDialog from '@/components/LayoutsDialog'
import { useTableContext } from '@/context/TableContext'
import useDisclosure from '@/hooks/useDisclosure'
import { ArrowDownToLine, FileUp, PlusCircle, RefreshCcw } from 'lucide-react'
import { ReactNode } from 'react'

interface DadosMestreHeaderActionsProps {
    CustomButtons?: ReactNode
    layout?: boolean
    onAdd?: () => void
    onDownload?: () => void
    onRefech?: () => void
    onBulk?: () => void
}

const DadosMestreHeaderActions = ({
    CustomButtons,
    layout,
    onAdd,
    onBulk,
    onDownload,
    onRefech,
}: DadosMestreHeaderActionsProps) => {
    const {
        isOpen: isLayoutsDialogOpen,
        onOpenChange: onLayoutsDialogOpenChange,
    } = useDisclosure()
    const {
        isOpen: isCreateLayoutsDialogOpen,
        onOpenChange: onCreateLayoutsDialogOpenChange,
    } = useDisclosure()

    const { tableId } = useTableContext()
    return (
        <>
            {CustomButtons}
            {onAdd && (
                <>
                    <ButtonWithTooltip
                        className="flex items-center justify-center w-auto gap-2 px-4 rounded-md"
                        tooltipContent={<p>Adicionar</p>}
                        onClick={onAdd}
                        size="default"
                    >
                        <PlusCircle size={18} />
                        Novo
                    </ButtonWithTooltip>
                    <div className="w-[1px] h-4 bg-neutral-300" />
                </>
            )}
            {onRefech && (
                <>
                    <ButtonWithTooltip
                        tooltipContent={<p>Atualizar</p>}
                        onClick={onRefech}
                        variant="ghost"
                    >
                        <RefreshCcw size={18} />
                    </ButtonWithTooltip>
                    <div className="w-[1px] h-4 bg-neutral-300" />
                </>
            )}

            {onBulk && (
                <>
                    <ButtonWithTooltip
                        tooltipContent={<p>Carga</p>}
                        onClick={onBulk}
                        variant="ghost"
                    >
                        <FileUp size={18} />
                    </ButtonWithTooltip>
                    <div className="w-[1px] h-4 bg-neutral-300" />
                </>
            )}
            {onDownload && (
                <>
                    <ButtonWithTooltip
                        tooltipContent={<p>Download</p>}
                        onClick={onDownload}
                        variant="ghost"
                    >
                        <ArrowDownToLine size={18} />
                    </ButtonWithTooltip>
                    <div className="w-[1px] h-4 bg-neutral-300" />
                </>
            )}
            {layout && (
                <>
                    <LayoutDialog
                        isOpen={isLayoutsDialogOpen}
                        onCreateDialogOpenChange={
                            onCreateLayoutsDialogOpenChange
                        }
                        onOpenChange={onLayoutsDialogOpenChange}
                        tableId={tableId}
                    />
                    <CreateLayoutDialog
                        isOpen={isCreateLayoutsDialogOpen}
                        onOpenChange={onCreateLayoutsDialogOpenChange}
                        tableId={tableId}
                    />
                </>
            )}
        </>
    )
}

export default DadosMestreHeaderActions
